import { EventBus } from 'primereact/utils';

var OverlayService = EventBus();

export { OverlayService };
